import wretch from 'wretch';
export default wretch().defer((api, _, options) => {
    const token = options.token || sessionStorage.getItem('token');
    return api.auth(`Groups groups_token=${token}`);
});
//# sourceMappingURL=index.js.map